import { EmptyStateIllustration } from '@mdvip/shared/components/blocks/EmptyStateIllustration';
import { useTranslation } from 'react-i18next';

/** Stands in on the directory page for a view whose component isn't built yet. */
export function MyPatientDirectoryPlaceholder() {
  const { t } = useTranslation('providers');

  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-xl border-2 border-dashed border-border py-16">
      <EmptyStateIllustration className="w-48 opacity-40" />
      <p className="text-sm text-muted-foreground">{t('pages.patients.comingSoon')}</p>
    </div>
  );
}
